/* eslint-disable camelcase */

export default class TaskReportParameters {
  constructor ({ product_id, activation_price, original_price }) {
    this.productId = product_id
    this.activationPrice = activation_price
    this.originalPrice = original_price
  }
}



// WEBPACK FOOTER //
// ./src/app/activations/models/TaskReportParameters.js